<template>
  <a-modal width="600px" centered v-model:open="isOpen">
    <template #title>
      <span class="text-lg font-bold">{{ $t("Pos.PrintConfirm") }}</span>
    </template>

    <div>
      <span>{{ $t("Pos.PrintConfirmMessage") }}</span>
    </div>
    <div class="flex gap-2 mt-4">
      <button
        class="flex w-full rounded-md items-center justify-center text-white"
        :style="{ backgroundColor: backgroundColor }"
        @click="print"
      >
        {{ $t("Pos.Print") }}
      </button>
      <button
        class="flex w-full rounded-md py-2 items-center justify-center"
        :style="{
                border: `2px solid ${backgroundColor}`,
                color: backgroundColor,
                backgroundColor: 'transparent',
              }
        "
        @click="cancel"
      >
        {{ $t("Pos.Cancel") }}
      </button>
    </div>

    <template #footer></template>
  </a-modal>
</template>

<script setup lang="ts">
import { ref, watch, defineProps, defineEmits, onMounted } from "vue";

const props = defineProps<{
  open: boolean;
}>();

const isOpen = ref(props.open);

watch(
  () => props.open,
  (newValue) => {
    isOpen.value = newValue;
  },
);

watch(isOpen, (newValue) => {
  emit("update:open", newValue);
});

const emit = defineEmits<{
  (e: "update:open", value: boolean): void;
  (e: "print"): void;
  (e: "cancel"): void;
}>();

const print = () => {
  emit("print");
};
const cancel = () => {
  isOpen.value = false;
  emit("cancel");
};

const backgroundColor = ref("");

onMounted(() => {
  const bgColor = localStorage.getItem("themeTemplate");

  if (bgColor) {
    backgroundColor.value = JSON.parse(bgColor).primaryColor;
  } else {
    backgroundColor.value = "#fc8019";
  }
});
</script>
